import { useDataContext } from 'context/data/dataContext';
import { IntlProvider } from 'react-intl';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import vi from './vi.json';
import ar from './ar.json';
import cs from './czech.json';
import de from './de.json';
import he from './he.json';
import hk from './hk.json';
import hu from './hu.json';
import io from './ido.json';
import ja from './ja.json';
import ko from './ko.json';
import ml from './malay.json';
import pl from './pl.json';
import pt from './pt.json';
import ro from './ro.json';
import ru from './ru.json';
import sv from './sv.json';
import th from './thai.json';
import tr from './turk.json';
import tw from './tw.json';
import az from './az.json';
import hy from './hy.json';
import ka from './ka.json';
import kk from './kk.json';
import ky from './ky.json';
import tg from './tg.json';
import uz from './uz.json';
import mn from './Mongolian.json';

type Locale = Record<string, string>;
interface Locales {
  [locale: string]: Locale
}

const defaultLocale = 'en';
const createPlaceholderLocales = (baseLocale: Locale): Locale => {
  return Object.keys(baseLocale).reduce((acc, key: string) => {
    return {
      ...acc,
      [key]: `${(baseLocale)[key]}`,
    };
  }, {} as Locale)
};
const locales: Locales = {
  placeholder: createPlaceholderLocales(en),
  en,
  es,
  fr,
  vi,
  ar,
  cs,
  de,
  he,
  hk,
  hu,
  io, 
  ja,
  ko,
  ml,
  pl,
  pt,
  ro,
  ru,
  sv,
  th,
  tr,
  tw,
  az,
  hy,
  ka,
  kk,
  ky,
  tg,
  uz,
  mn,
};
const localesList = Object.keys(locales);

export function extractValidLocale(locales: readonly string[]): string {
  return locales
    .filter((locale) => typeof locale === 'string')
    .reduce((acc, locale) => ([...acc, locale, locale.split('-')[0]]), [] as string[])
    .find(locale => localesList.includes(locale))
    || defaultLocale;
}

export function LocalizedApp({ children }: { children: JSX.Element }): JSX.Element {
  const { locale } = useDataContext();
  const messages = Object.assign({}, locales.placeholder, locales[locale]);

  return (
    <IntlProvider messages={messages} locale={locale} defaultLocale={defaultLocale}>
      {children}
    </IntlProvider>
  )
}
